import {Option, option} from "ts-option";
import {store} from "../../navigation/ReduxProvider";
import JobStatus from "../../model/job/JobStatus";
import {RootState} from "../reducer/root/RootState";

/**
 * Gets Job status.
 * @param {string} id Job status identifier to get.
 * @param {RootState} state
 * @returns {Option<JobStatus>} JobStatus.
 */
export function getJobStatus(id: string, state: RootState = store.getState()): Option<JobStatus> {
	const statuses = state.jobStatus.jobStatuses.getOrElse([]);
	const status = statuses.filter((js) => js.id === id);
	return option(status[0]);
}
